import VueCookies from "vue-cookies";
import { EncryptAES, DecryptAES } from "./crypto";
import store from "../../store/store";

const ulsname = "_cmauls";
const utkn = "_cmautk";
const sessckname = "_cmsess";
const sessexp = "30d";
const filterstorage = "product_filters";

function SetCookie(name, value, exp = sessexp) {
  VueCookies.set(name, value, {
    expires: exp,
    path: "/",
    secure: true,
    sameSite: "Strict",
  });
}

function LoadCookie(name) {
  if (VueCookies.isKey(name)) return VueCookies.get(name);
  return null;
}

function SetUserToken(tkn) {
  SetCookie(utkn, tkn);
}

function SetUser(user) {
  if (!user) {
    localStorage.removeItem(ulsname);
  } else {
    let tk = LoadCookie(utkn);
    if (tk) {
      localStorage.setItem(ulsname, EncryptAES(JSON.stringify(user), tk));
    }

    if (store && store.commit) {
      store.commit("setUser", user);
    }
  }
}

function LoadUser() {
  if (localStorage.getItem(ulsname) !== null) {
    try {
      let tk = LoadCookie(utkn);
      if (!tk) {
        localStorage.removeItem(ulsname);
        return null;
      }
      let u = JSON.parse(DecryptAES(localStorage.getItem(ulsname), tk));
      return u;
    } catch (err) {
      console.error("Decryption error:", err);
      localStorage.removeItem(ulsname);
      return null;
    }
  }
  return null;
}

function SetSession(tkn) {
  SetCookie(sessckname, tkn, "Session");
}

function GetSession() {
  return VueCookies.get(sessckname);
}

function RemoveSession() {
  VueCookies.remove(sessckname);
  VueCookies.remove(utkn);
}

function AuthUser(user, utk, stk) {
  SetUserToken(utk);
  SetUser(user);
  SetSession(stk);
}

function SaveStatePlugin(store) {
  store.subscribe((mutation, state) => {
    // setUser olmasa da user dəyişibsə yaz
    if (mutation.type !== "setUser" && state.user) {
      SetUser(state.user);
    }
  });
}

export function saveFilters(filters) {
  try {
    localStorage.setItem(filterstorage, JSON.stringify(filters));
  } catch (e) {
    console.error("Failed to save filters:", e);
  }
}

export function loadFilters() {
  try {
    const savedFilters = localStorage.getItem(filterstorage);
    if (savedFilters) {
      return JSON.parse(savedFilters);
    }
  } catch (e) {
    console.error("Failed to load filters:", e);
  }
  return {};
}

/* ✅ YENİ: token cookie-ni oxu (AES üçün lazımdır) */
function GetUserToken() {
  return LoadCookie(utkn);
}

/* ✅ YENİ: token/session dəyişmədən yalnız user-i yenilə */
function RefreshUserOnly(user) {
  const tk = LoadCookie(utkn);
  if (!tk) return false;

  // SetUser həm store commit edir, həm AES ilə localStorage-a yazır
  SetUser(user);
  return true;
}

export {
  SetUser,
  LoadUser,
  SaveStatePlugin,
  GetSession,
  RemoveSession,
  AuthUser,
  SetCookie,
  LoadCookie,
  ulsname,
  RefreshUserOnly, // ✅ yeni export
  GetUserToken,    // ✅ yeni export
};
